import React from "react";
import {Avatar} from "antd";

const userImageList = [
  {
    id: 1,
    image: "https://via.placeholder.com/150x150",
  },
  {
    id: 2,
    image: "https://via.placeholder.com/150x150",
  },
  {
    id: 3,
    image: "https://via.placeholder.com/150x150",

  },
  {
    id: 4,
    image: "https://via.placeholder.com/150x150",
    name: 'Mila Alba',
    rating: '5.0',
    deals: '27 Deals'
  },
]

export const aboutList = [
  {
    id: 1,
    title: 'Works at',
    icon: 'company',
    userList: '',
    desc: ['G-axon Tech Pvt. Ltd.']
  },
  {
    id: 2,
    title: 'Birthday',
    icon: 'birthday-new',
    userList: '',
    desc: ['Oct 25, 1984']
  },
  {
    id: 3,
    title: 'Went to',
    icon: 'graduation',
    userList: '',
    desc: ['Oxford University']
  },
  {
    id: 4,
    title: 'Lives in London',
    icon: 'home',
    userList: '',
    desc: ['From Switzerland']
  },
  {
    id: 5,
    title: '4 Family Members',
    icon: 'family',
    userList: [<ul className="gx-list-inline gx-mb-0" key={1}>
      {userImageList.map((user, index) =>
        <li className="gx-mb-2" key={index}>
          <Avatar className="gx-size-30" src={user.image}/>
        </li>
      )
      }
    </ul>],
    desc: ''
  },
];

export const eventList = [
  {
    id: 1,
    image: "https://via.placeholder.com/575x480",
    title: 'Sundance Film Festival.',
    address: 'Downsview Park, Toronto, Ontario',
    date: 'Feb 23, 2019',
  },
  {
    id: 2,
    image: "https://via.placeholder.com/575x480",
    title: 'Underwater Musical Festival.',
    address: 'Street Sacramento, Toronto, Ontario',
    date: 'Feb 24, 2019',
  },
  {
    id: 3,
    image: "https://via.placeholder.com/575x480",
    title: 'Village Feast Fac',
    address: 'Union Street Eureka',
    date: 'Oct 25, 2019',
  }
];

export const contactList = [
  {
    id: 1,
    title: 'Email',
    icon: 'email',
    desc: [<span className="gx-link" key={1}>kiley.brown@example.com</span>]
  },
  {
    id: 2,
    title: 'Web page',
    icon: 'link',
    desc: [<span className="gx-link" key={2}>example.com</span>]
  }, {
    id: 3,
    title: 'Phone',
    icon: 'phone',
    desc: ['+1-987 (454) 987']
  },
];

export const friendList = [
  {
    id: 1,
    image: "https://via.placeholder.com/150x150",
    name: 'Chelsea Johns',
    status: 'online'

  },
  {
    id: 2,
    image: "https://via.placeholder.com/150x150",
    name: 'Ken Ramirez',
    status: 'offline'
  },
  {
    id: 3,
    image: "https://via.placeholder.com/150x150",
    name: 'Chelsea Johns',
    status: 'away'

  },
  {
    id: 4,
    image: "https://via.placeholder.com/150x150",
    name: 'Ken Ramirez',
    status: 'away'
  },
];


export const contentdata = "<p><strong>%today_date%</strong></p> <p>&nbsp;</p> <p><strong>%company_name%</strong></p> <p><strong>%company_address%</strong></p> <p>&nbsp;</p> <p><strong>Dear %owner_name%,</strong></p> <p>&nbsp;</p> <p><strong>Thank you for allowing Mid-America Manufacturing Technology Center (MAMTC) to complete the LINK Profile for %company_name% After finalizing the on-site profile with you, MAMTC has developed a results document based upon the information that you provided during our discussion. The results document highlights areas of opportunities for&nbsp;Salina&nbsp;Planing Mill, Inc. and&nbsp;provides recommendations on how to minimize or resolve&nbsp;business gaps to help your&nbsp;company grow.</strong></p> <p>&nbsp;</p> <p><strong>We were pleased to be able to work with you and look forward to working with you in a continuing and growing relationship.</strong></p> <p>&nbsp;</p> <p><strong>Sincerely,</strong></p> <p>&nbsp;</p> <p>&nbsp;</p> <p>&nbsp;</p> <p><strong>%profiler_name%</strong></p> <p><strong>MAMTC</strong></p> <p><strong>10550&nbsp;Barkley, Suite 116</strong></p> <p><strong>Overland Park, KS 66221</strong></p> <p>&nbsp;</p> <p>&nbsp;</p> <p><span style='font-size:18px'><strong>Executive Overview</strong></span></p> <p><span style='font-size:16px'><strong>Introduction</strong></span></p> <p>Mid-America Manufacturing Technology Center (MAMTC) presents the LINK Profile to %company_name% as an introduction to the initiatives being offered to manufacturers. The initiatives include partnership, training, technology transfer and consulting services offered by MAMTC&nbsp;that&nbsp;are a result of the National Institute of Standards and Technology/Manufacturing Extension Partnership (MEP) Program.&nbsp;&nbsp;MAMTC is the Kansas MEP Center. There are 50 additional MEP Centers, one for each state and Puerto Rico.&nbsp;&nbsp;</p> <p>&nbsp;</p> <p>This review represents the on-site discussions and technical and company review conducted by %profiler_name% with MAMTC.</p> <p>&nbsp;</p> <p>Measurements and comparisons provided in the LINK Profile results are based upon a compilation of data from&nbsp;over&nbsp;200 manufacturers.&nbsp;&nbsp;&nbsp;Those manufacturers are represented by a variety of business sizes, geographical regions and product lines.&nbsp;&nbsp;&nbsp;Thus, the comparisons provided in the LINK Profile are not a &ldquo;like for like&rdquo; comparison. However, they do provide a relative comparison to manufacturers&nbsp;industry.&nbsp;&nbsp;</p> <p>&nbsp;</p> <p>The comparisons provided in the LINK Profile should not be viewed as a gauge or indicator of the success or abilities of the participating manufacturer. They should be viewed as a resource to show where areas of opportunity are to assist with future growth of the manufacturer.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p> <p>&nbsp;</p> <p>*The best in class is the highest score attained overall and in each of the four modules by a&nbsp;company. Scores from several different companies may constitute the Best in Class comparison scores.</p> <p>&nbsp;</p> <p>*The average score is&nbsp;a mean&nbsp;of all the scores of the companies that have gone through the assessment.</p> <p>&nbsp;</p> <p>Please let us know if you have any questions about the LINK Profile results.</p> <p>&nbsp;</p> <p><strong><span style='font-size:18px'>LINK&nbsp;Discovery</span></strong></p><p>%company_logo%</p><p><span style='font-size:16px'><strong>LINK Profile Completed:</strong></span></p> <p><strong>%assessment_submit_date%</strong></p> <p><strong>%company_name%</strong></p> <p><strong>%company_address%</strong></p> <p>&nbsp;</p> <p><span style='font-size:16px'><strong>Participants:</strong></span></p> <p><strong>%company_name%</strong></p> <p><strong>%owner_name%</strong></p> <p>&nbsp;</p> <p><strong>MAMTC</strong><br /> <strong>%profiler_name%</strong></p> <p>&nbsp;</p> <p><span style='font-size:16px'><strong>Link Results Scheduled:</strong></span></p> <p><strong>%Second_Meeting_Scheduled_Date%</strong></p> <p>&nbsp;</p> <p><span style='font-size:16px'><strong>Company Summary</strong></span></p> <p><strong>%company_summary%</strong></p> <p>&nbsp;</p> <p><strong><span style='font-size:16px'>LINK Profile Results&nbsp;</span></strong></p> <p>%section_loop_start%</p> <p><strong>Company&nbsp;Organization Development Average:&nbsp;%percentage_of_section%%</strong></p> <p><strong>Competitive Average:%competetive_avarage%%</strong></p> <p><strong>Best in Class:&nbsp;%best_in_class%%</strong></p> %graph_of_section% <p><span style='font-size:16px'><strong>%percentage_of_section%</strong><strong>%</strong>&nbsp; <strong>%section_name%</strong></span></p> <p>%possitive_recomen_of_questions%</p> <p>%section_loop_end%</p>";

